import { Injectable } from '@angular/core';

import { ApiService } from './api.service';
import { CONSTANTS } from '../../constants';

@Injectable({
    providedIn: 'root'
})

export class ChannelService extends ApiService {
    public getChannelList(api_url: any) {
        if (!api_url) {
            api_url = CONSTANTS.API.FEED_BASE_URL;
        }
        return this.get(CONSTANTS.API.CHANNEL.LIST, api_url);
    }
    public getServerList() {
        return this.get(CONSTANTS.API.CHANNEL.SERVER_LIST);
    }
    public setServerFeedMode(data: any, api_url: any) {
        let url: any = `${CONSTANTS.API.CHANNEL.MODE}?test_mode=${data.mode ? 1 : 0}`;
        return this.post(url, data, api_url);
    }
    public switchChannel(data: any, api_url: any) {
        return this.getQueryParams(CONSTANTS.API.CHANNEL.SWITCH, data, api_url);
    }
    public startStopChannel(data: any, api_url: any) {
        return this.getQueryParams(CONSTANTS.API.CHANNEL.START_STOP, data, api_url);
    }
    public getConnectionDetails() {
        return this.get(CONSTANTS.API.CHANNEL.CONN_DETAILS);
    }
}
